import { AttributeClient } from '@frontend/attribute/api';
import { Attribute, AttributeQueryParams } from '@frontend/attribute/types';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { Spinner } from '@frontend/elements';
import { getCorrectTranslation, useLocale } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import React, { useState } from 'react';

const ID = 'attribute-select';

export const AttributeSelectV2 = (props: ObjectSelectProps<Attribute, AttributeQueryParams>) => {
    const { currentAccount } = useAccountRepository();
    const { locale } = useLocale();
    const [q, cQ] = useState<Attribute | null>(null);

    if (!locale) return <Spinner />;
    return (
        <ObjectSelectInput<Attribute, AttributeQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Attribute'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cQ(v);
            }}
            disabled={props.disabled}
            required={props.required}
            queryParams={props.queryParams}
            value={q}
            idValue={props.value || q?.id}
            fetch={(arg) => AttributeClient.fetchAttributes({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(o) => getCorrectTranslation(locale, o, 'name')}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'category_id',
                          fetch: (pathParam) => AttributeClient.fetchAttribute(currentAccount, pathParam)
                      }
                    : undefined
            }
            isClearable={props.isClearable}
            subset={props.subset}
        />
    );
};
